import { BugReportParamsCreate } from '../../../shared/types/bugReport';
import { apiPost } from '.';

export async function createBugReport(bugReport: BugReportParamsCreate): Promise<Boolean> {
  return apiPost('/bug-report', bugReport);
}
